import { ObjetKStatusCode } from '@siclop/kstone-vue'

export class Profession extends ObjetKStatusCode {
  defaultHourlyRate: number = 0
  allowedActivityTypeIds: number[] = []

  constructor(data?: Partial<Profession>) {
    super(data)
    if (data) {
      this.defaultHourlyRate = data.defaultHourlyRate ?? 0
      this.allowedActivityTypeIds = data.allowedActivityTypeIds ?? []
    }
  }
}
